import { GET_SIZE_REQUEST, GET_SIZE_SUCCESS, GET_SIZE_ERROR } from "../actions/size"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const getSize = (state = initialState, action) => {
    switch (action.type) {
        case GET_SIZE_REQUEST:
            return {
                ...state,
                loading: true
            }

        case GET_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case GET_SIZE_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }

        default:
            return state;
    }
}

export default getSize